<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="form-group row mb-3">
                <div class="col-md-3">
                    <app-select-academic-year-only
                        (academicYearChanged)="onChangeAcademicYear($event)">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-3" style="display: none;">
                    <app-select-school-level-relation-v2
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        (eventData)="onGetEventSchoolLocation($event)"
                        [isDisabled]="!this.paramForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
            </div>
        </div>
        <div>
            <div>
                <button class="btn btn-primary mt-2 mb-2" type="button" (click)="checkAllCheckboxes()" *ngIf="dataAccumulation.length !== 0">Select All</button>
            </div> 
            <table mat-table *ngIf="dataSchool.length > 0 && !loading"
                   [dataSource]="dataSchool" multiTemplateDataRows
                   >

                <ng-container matColumnDef="school_short_address">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'SCHOOL_SHORT_ADDRESS' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.school_short_address || '-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="accumulation">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_ACCUMULATION' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-weight">
                        <label class="switch">
                            <input type="checkbox" [formControl]="checkboxForm.controls[element.school_location_id]">
                            <span class="slider round"></span>
                        </label>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                </tr>
            </table>
        </div>
        <div style="display: flex; justify-content: flex-end;">
            <button class="btn btn-success mt-4 mb-4" type="button" (click)="onSaveAccumulationSetup()" *ngIf="dataAccumulation.length !== 0 && auth.permissions['SCHOOL_PROGRAM_PAYMENT_ACCUMULATION_SETUP_EDIT']">Save</button>
        </div> 
    </mat-card-content>
</mat-card>